// @flow
import { handleResponseWithNon200Errors, makeGet } from './helpers';

type FetchItemShippingEstimate = {
    authToken: string,
    countryCode: string,
    deployment: string,
    itemId: number,
    postalCode: string,
};

export default {
    fetchItemShippingEstimate: ({
        authToken,
        deployment,
        countryCode,
        itemId,
        postalCode,
    }: FetchItemShippingEstimate) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                authToken,
                deployment,
                path: '<SHIPPING-API>getestimate',
                queryParams: { countryCode, itemId, postalCode },
            });
            request.end((err, response) => handleResponseWithNon200Errors({ err, reject, resolve, response }));
        }),
};
